var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Item')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "hidden-sm-and-up"
  }, [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.item.m_Name, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.item.m_Name))])])]), _c('div', {
    style: {
      'min-height': _vm.$size(64) + 16 + 'px'
    }
  }, [_c('div', {
    staticClass: "float-right px-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.itemicon.format(_vm.item.m_ID) + '.png',
      "target": "_blank"
    }
  }, [_c('v-avatar', {
    key: "item-icon-".concat(_vm.id),
    attrs: {
      "size": _vm.$size(64)
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.itemicon.format(_vm.item.m_ID) + '.jpg'
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "hidden-xs-only"
  }, [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.item.m_Name, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.item.m_Name))])])]), _c('p', {
    staticClass: "px-4"
  }, [_vm._v(_vm._s(_vm.item.m_DetailText.replace(/\n/g, '')))])]), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('Type'),
      "v": _vm.$t("Item Type.".concat(_vm.type)),
      "width": "33%"
    }
  }), _vm.type != 10 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Category'),
      "v": _vm.$t("Item Category.".concat(_vm.item.category)),
      "width": "33%"
    }
  }) : _c('KeyValue', {
    attrs: {
      "k": _vm.$t('From Event'),
      "v": _vm.$name(_vm.event.m_ListName),
      "width": "33%"
    }
  }), _vm.item.m_Type == 0 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Experience'),
      "v": _vm.item.m_TypeArgs[1],
      "width": "33%"
    }
  }) : _vm._e(), _vm.item.m_Type == 3 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Experience'),
      "v": _vm.item.m_TypeArgs[0],
      "width": "33%"
    }
  }) : _vm._e(), _vm.item.m_SaleAmount ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Sale Amount'),
      "v": _vm.item.m_SaleAmount,
      "width": "33%"
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }